import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { filter, mergeMap, tap } from "rxjs/operators";
import { AuthenticationService } from '../../../access/shared/authentication/authentication.service';
import { UserToken } from '../../../access/shared/token/token';
import { ConfigService } from '../../../config/config.service';
import { Client } from '../../shared/client/client';
import { ClientService } from '../../shared/client/client.service';
import { AddBasketRequest } from './add-basket-request';
import { CommandeLine } from './commande-line';

@Injectable({
  providedIn: 'root'
})
export class BasketService {


  basketCount$: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  basketCountWarning$: BehaviorSubject<number> = new BehaviorSubject<number>(0);


  constructor(
    private configService: ConfigService,
    private http: HttpClient,
    private clientService: ClientService,
    private authenticationService: AuthenticationService
  ) {
    this.authenticationService.currentUser$.pipe(filter<UserToken>(user => user.isLoggedIn())).subscribe(user => {
      this.updateBasketCount();
      this.updateClient();
    });

  }

  getBasket(): Observable<Array<CommandeLine>> {
    return this.configService.getConfig().pipe(
      mergeMap(config => {
        return this.http.get<Array<CommandeLine>>(config.apiPoint + config.getPanier);
      })
    )
  }

  private updateBasketCount() {
    this.getBasketCount().subscribe(count => {
      this.basketCount$.next(count['total'])
      this.basketCountWarning$.next(count['warning'])
    });
  }

  private getBasketCount(): Observable<Array<number>> {
    return this.configService.getConfig().pipe(
      mergeMap(config => {
        return this.http.get<Array<number>>(config.apiPoint + config.getPanierCount);
      })
    )
  }

  addBasketLine(request: AddBasketRequest): Observable<CommandeLine> {
    return this.configService.getConfig().pipe(
      mergeMap(config => {
        return this.clientService.getFirstCurrentClient().pipe(
          mergeMap(client => {
            return this.http.post<CommandeLine>(config.apiPoint + config.getPanier,
              Object.assign(request, {
                "client": client.id
              }));
          })
        );
      }),
      tap(cmd => this.updateBasketCount())
    );
  }

  deleteBasketLine(commandeLine: CommandeLine): Observable<Array<CommandeLine>> {
    return this.configService.getConfig().pipe(
      mergeMap(config => {
        return this.http.delete<Array<CommandeLine>>(config.apiPoint + config.deleteBasket.replace("{panier}", commandeLine.id + ""));
      }),
      tap(cmd => this.updateBasketCount())
    )
  }

  submit(): Observable<Object> {
    return this.configService.getConfig().pipe(
      mergeMap(config => {
        return this.http.get(config.apiPoint + config.submitBasket);
      }),
      tap(cmd => this.updateBasketCount())
    )
  }

  updateClient() {
    if (localStorage.getItem('user_token') && localStorage.getItem('client')) {
      let client = JSON.parse(localStorage.getItem('client')) as Client
      this.clientService.getClient(client.id).subscribe(value => {
        this.clientService.selectClient(value)
        localStorage.setItem('client', JSON.stringify(value))
      })
    }
  }
}
